@use '~/theme/theme' as *;

.toastRegion {
  flex-direction: column;
  gap: 8px;
  display: flex;
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: z-index(popup);
}
